export default __webpack_public_path__ + "static/media/home4.6540d637.png";